"use client";

import { useMsal } from '@azure/msal-react'
import { useNetworkStatus } from '../hooks/useNetworkStatus'
import { loginRequest } from '../services/authConfig'
import { recoverFromStaleInteraction } from '../services/msalRecovery'
import { rememberReturnUrl } from '../services/returnUrl'
import { showToast } from '../state/appState'

export function NetworkStatusBanner() {
  const { isOnline, pendingCount, isSyncing, authRequired, triggerSync } = useNetworkStatus()
  const { instance } = useMsal()

  if (isOnline && pendingCount === 0 && !authRequired) return null

  const statusText = !isOnline
    ? "You're offline — changes are saved locally."
    : isSyncing
      ? 'Syncing offline changes…'
      : authRequired
        ? 'Sign in to sync your offline changes.'
        : `${pendingCount} offline change${pendingCount === 1 ? '' : 's'} pending.`

  return (
    <div className={`network-status-banner ${isOnline ? '' : 'offline'}`}>
      <span className="network-status-dot" />
      <span className="network-status-text">{statusText}</span>
      {pendingCount > 0 && (
        authRequired ? (
          <button
            className="secondary btn-sm"
            disabled={!isOnline}
            onClick={() => {
              // loginRedirect, not loginPopup — popups get blocked too
              // unreliably in practice. MSAL brings the return leg back to
              // redirectUri ("/") regardless of where it started, so the page
              // the user is on has to be recorded here; AuthProvider restores
              // it once handleRedirectPromise resolves.
              rememberReturnUrl()
              instance.loginRedirect(loginRequest).catch((err) => {
                // An abandoned sign-out leaves MSAL refusing new interactions;
                // a reload is what clears it. See services/msalRecovery.
                if (recoverFromStaleInteraction(err)) return
                console.error('Sign-in failed:', err)
                showToast('Sign-in failed. Please try again.', 'error')
              })
            }}
          >
            Sign In to Sync
          </button>
        ) : (
          <button
            className="secondary btn-sm"
            disabled={!isOnline || isSyncing}
            onClick={() => { void triggerSync() }}
          >
            {isSyncing ? 'Syncing…' : 'Sync Now'}
          </button>
        )
      )}
    </div>
  )
}
